import { useState } from 'react';

export const useCarouselApi = () => {
  const [carouselApi, setCarouselApi] = useState(null);

  const onCarouselApiReady = (api) => {
    setCarouselApi(api);
  };

  return {
    onCarouselApiReady,
    carouselApi,
  };
};
